import { Global } from '@emotion/react'

const appUrl = process.env.REACT_APP_ID_BASE_URL
const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'Barlow-Light';
        font-weight: 300;
        font-display: swap;
        src: url('${appUrl}assets/fonts/Barlow-Light.woff') format('woff');
      }
      @font-face {
        font-family: 'Barlow-Medium';
        font-weight: bold;
        font-display: swap;
        src: url('${appUrl}assets/fonts/Barlow-Medium.woff') format('woff');
      }
      `}
  />
)

export default Fonts
